import { CREATE_BUSINESS_CARD_RECEIVE, CREATE_BUSINESS_CARD_PREVIEW, CREATE_BUSINESS_CARD_CREATE, CREATE_BUSINESS_CARD_LOAD_ERROR, CREATE_BUSINESS_CARD_SHOW_INFO, CREATE_BUSINESS_CARD_HIDE  } from '../Actions/CreateBusinessCard.action';

const DEFAULT_STATE = {
    isPreview: false,
    formEl: null,
    AdjustButton: null,
};

export const createBusinessCard = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CREATE_BUSINESS_CARD_RECEIVE:
        case CREATE_BUSINESS_CARD_PREVIEW:
        case CREATE_BUSINESS_CARD_CREATE: 
        case CREATE_BUSINESS_CARD_LOAD_ERROR:
        case CREATE_BUSINESS_CARD_SHOW_INFO:
        case CREATE_BUSINESS_CARD_HIDE:

            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}